import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const CallCard = () => {
  return (
    <Container
      fluid
      className="ind-bg-color empty-space-my-one mt-5
"
    >
      <Container className="bg-purple-color-strong rounded-5 ps-lg-5 pt-5 pb-0">
        <Row className="align-items-center mt-5">
          <Col lg={6} className="text-white px-5">
            <h1 className="fs-four-title anybody-font fw-bold">
              Revolutionize Customer Support with 24/7 AI Answering!
            </h1>
            <p className="fs-two anybody-font my-4">
              Upgrade your customer experience today—let AI do the answering!
            </p>
            <Button
              variant="light"
              className="purple-color fw-bold px-4 py-2 cx-btn"
              to="/signup"
              as={Link}
            >
              Get Started for Free
              <img
                className="ms-2"
                src="/assets/arrow-right-bl.svg"
                alt="Play"
              />
            </Button>
          </Col>

          <Col
            lg={6}
            className="px-0 d-flex justify-content-end align-items-end"
          >
            <img
              src="/assets/Dashboard_2.png"
              alt="Dashboard Overview"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default CallCard;
